<template>
	<t-form-group
		:horizontal="horizontal"
		:rowGap="rowGap"
		:columnGap="columnGap"
		:marginTop="marginTop"
		:marginBottom="marginBottom"
	>
		<template slot="header">
			<t-popover
				:showPopover="popoverIsVisible"
				:marginY="6"
				:style="getStyle"
				direction="bottom"
				:min-width="150"
				relative
			>
				<div slot="target" class="select-wrapper">
					<slot name="label" :item="selectedItem">{{defaultLabelText}}</slot>
					<t-icon-button
						type="bp"
						icon="caret-down"
						appearance="transparent"
						iconSize="sm"
						@click="togglePopover"
					/>
				</div>

				<t-menu v-if="items">
					<t-menu-options-group
						:title="title"
						:items="items"
						:selectedItem="selectedItem"
						groupStyle="combobox"
						@change="onChange"
					>
						<template v-slot="slotProps">
							<t-menu-combobox-option-item
								:value="slotProps.item"
								:selected="slotProps.isSelected"
							>
								<slot name="menuitemlabel" :item="slotProps.item">{{ slotProps.item }}</slot>
							</t-menu-combobox-option-item>
						</template>
					</t-menu-options-group>
				</t-menu>
			</t-popover>
		</template>
		<slot />
	</t-form-group>
</template>

<script>
import formMixin from '../../inputs/formMixin';
import popoverMixin from '../../inputs/popoverMixin';
import TIconButton from '../../buttons/TIconButton';
import TPopover from '../../overlays/TPopover';
import TFormGroup from './TFormGroup';
import {
	TMenu, TMenuOptionsGroup, TMenuComboboxOptionItem
} from '../../menu';
export default {
	name: 'TSelectableFormGroup',
	components: { TFormGroup, TIconButton, TPopover, TMenu, TMenuOptionsGroup, TMenuComboboxOptionItem },
	mixins: [ formMixin, popoverMixin ],
	props: {
		items: Array,
		title: String,
		selectedItem: [ Object, String ],
		defaultLabel: String,
		horizontal: Boolean,
		rowGap: String,
		columnGap: String,
		marginTop: String,
		marginBottom: String,
	},
	computed: {
		defaultLabelText() {
			return this.defaultLabel ? this.defaultLabel : this.selectedItem;
		}
	},
	methods: {
		onChange(value) {
			this.popoverSetHidden();
			this.$emit('change', value);
		},
		togglePopover() {
			this.popoverToggle();
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
.select-wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>